<template>
  <v-alert
    style="padding: 12px !important"
    v-if="!isCheckOut && minOrderSum - amount > 0"
    class="alert pa-2 mb-10"
    icon="mdi-information"
    color="#E46E71"
    type="success"
    title="מינימום ההזמנה"
  >
    <span class="text"
      >שימו לב, מינימום הזמנה <b> ₪{{ formatPrice(minOrderSum) }} </b> נותר
      <b> ₪{{ formatPrice(minOrderSum - amount) }} </b>
      להזמנה</span
    >
  </v-alert>
</template>

<script>
import { mapGetters } from "vuex";
import { formatPrice } from "@/utilities.js";
export default {
  props: {
    isCheckOut: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '100%',
    }
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price);
    },
  },
  computed: {
    amount() {
      return (
        this.getTotalCartBeforeVAT + this.getTotalCartBeforeVAT * this.getVat
      );
    },
    ...mapGetters({
      getTotalCartBeforeVAT: "Orders/getTotalCartBeforeVAT",
      minOrderSum: "Orders/getMinOrderSum",
      getVat: "Orders/getTaxPercent",
    }),
  },
};
</script>

<style lang="scss">
.alert {
  width: v-bind(width);
  border-radius: 10px;
  .v-alert__content {
    color: white !important;
  }
  .text {
    font-weight: 300;
    b {
      font-weight: 700;
    }
  }
}
</style>
